import { render } from "./HeroiconsSolidClipboardCheck.vue?vue&type=template&id=21d124e0"
const script = {}

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidClipboardCheck.vue"]])

export default __exports__